import React, { useState } from "react";

const CorporateVideo = ({
  videoId = "u7T3f3nNT8k",
  title = "EXPLORE THE SCIENCE BEHIND NUTRALIKE",
  description = "This corporate video gives you a closer look at our state-of-the-art facilities, advanced R&D process, and quality-driven production standards. Watch & follow Nutralike",
}) => {
  const brandGreen = "#335235";
  const [playing, setPlaying] = useState(false);
  const thumbnail = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  const youtubeUrl = `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&autoplay=1`;

  return (
    <section className="w-full bg-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-screen-2xl mx-auto">

        {/* Header */}
        <div className="text-center mb-5">
          <h2
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif leading-tight"
            style={{ color: brandGreen }}
          >
            Corporate<span className="gradient-text"> Video </span>
          </h2>
        </div>

        {/* Underline */}
        <div
          className="w-24 h-[2px] mx-auto mt-2 mb-6"
          style={{
            background:
              "linear-gradient(90deg, transparent 0%, #355931 30%, #A4BE2C 70%, transparent 100%)",
          }}
        />

        {/* Grid — stacks on mobile, side-by-side on lg+ */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 items-stretch">

          {/* Left - Text */}
          <div
            className="p-8 sm:p-12 lg:p-16 flex flex-col justify-center"
            style={{ backgroundColor: "#899F87" }}
          >
            <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#1a2e18] mb-6 leading-tight">
              {title}
            </h3>
            <p className="text-base sm:text-lg text-[#1a2e18] leading-relaxed opacity-95">
              {description}
            </p>
          </div>

          {/* Right - Video */}
          <div className="relative w-full bg-black" style={{ aspectRatio: "16/9" }}>
            {playing ? (
              <iframe
                width="100%"
                height="100%"
                src={youtubeUrl}
                title="NUTRALIKE Corporate Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                className="absolute inset-0 w-full h-full"
              />
            ) : (
              <div
                className="absolute inset-0 w-full h-full cursor-pointer group"
                onClick={() => setPlaying(true)}
                role="button"
                tabIndex={0}
                aria-label="Play corporate video"
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setPlaying(true);
                  }
                }}
              >
                <img
                  src={thumbnail}
                  alt=""
                  role="presentation"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-16 sm:w-20 sm:h-20 bg-red-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-200 shadow-lg">
                    <svg className="w-6 h-6 sm:w-8 sm:h-8 text-white ml-1" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                </div>
              </div>
            )}
          </div>

        </div>
      </div>
    </section>
  );
};

export default CorporateVideo;